const ko = {
  language: { label: '언어' },
  nav: {
    gift: '선물 · 90일 무료',
    pricing: '요금제 및 가격',
    features: '기능',
    ecosystem: '가족 생태계',
    clubs: '클럽',
    academy: '아카데미',
    lab: 'ROMIND LAB',
    safety: '안전',
    research: '연구',
    insights: '인사이트',
    about: '소개',
    parentSafety: '부모 안전 안내',
    joinTesting: '테스트 참여',
    contact: '문의',
    toggleMenu: '메뉴 열기',
  },
  download: {
    nav: '앱 다운로드',
    cta: 'Google Play에서 다운로드',
    available: '지금 이용 가능',
    headline: 'ROMIND KIDS가 Google Play에 출시되었습니다!',
    description: '9~14세 어린이를 위한 우정, 창의 활동, 학습의 공간입니다. 안전을 중요하게 설계한 Android 앱을 다운로드해 보세요.',
    scan: 'QR 코드를 스캔하면 Google Play의 ROMIND KIDS 페이지로 이동합니다.',
    qrAlt: 'Google Play에서 ROMIND KIDS를 다운로드하는 QR 코드',
  },
  footer: {
    tagline: '9–14세 어린이를 위한 더 안전한 창의적 세계이자 ROMIND Family Circle의 기반입니다.',
    platform: '플랫폼',
    legal: '법적 안내',
    home: '홈',
    features: 'ROMIND KIDS 기능',
    ecosystem: '가족 생태계',
    clubs: '클럽 및 챌린지',
    academy: 'ROMIND Academy',
    lab: 'ROMIND LAB',
    ventureStudio: 'Venture Studio',
    safety: '안전',
    safetyResearch: '안전 연구',
    parentSafety: '부모 안전 안내',
    insights: '인사이트',
    joinTesting: '테스트 참여',
    about: '소개',
    contact: '문의',
    privacy: '개인정보 처리방침',
    terms: '서비스 이용약관',
    copyright: '사용자 콘텐츠 및 저작권',
    community: '커뮤니티 가이드라인',
    childSafetyModeration: '아동 안전 및 모더레이션',
    reportHandling: '신고 처리',
    dataRetention: '데이터 보관 및 삭제',
    deleteAccount: '계정 삭제',
    childSafetyOverview: '아동 안전 개요',
    childSafetyResearch: '아동 안전 연구',
    rights: '© 2025–2026 ROMIND KIDS — 창립자가 직접 운영하는 프로젝트. 모든 권리 보유.',
    safetyPrinciples: '아동 안전 원칙을 바탕으로 설계되었습니다',
  },
  legal: {
    eyebrow: '법적 안내',
    back: 'ROMIND KIDS로 돌아가기',
    lastUpdated: '최종 업데이트: {date}',
    operatorInfo: '운영자 정보:',
    otherDocs: '기타 법적 및 안전 관련 문서',
  },
};

export default ko;